import { FaRegHandshake, FaFileContract, FaRocket, FaBitcoin, FaEthereum, FaCoins } from "react-icons/fa";

import {Button} from "@nextui-org/react"; 
const HowToGetStarted = () => {
  return(
  <div className="how-to-get-started bg-white py-10 flex flex-col items-center justify-center">
    <h2 className="text-3xl md:text-3xl text-center font-medium mb-8">How to Get Started</h2>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-center justify-center">
      <div className="step text-center flex flex-col items-center">
        <FaRegHandshake className="text-6xl mb-4 text-blue-500" />
        <h3 className="text-lg font-semibold">Step 1: Sign Up</h3>
        <p>Create an account and verify your identity.</p>
      </div>
      <div className="step text-center flex flex-col items-center">
        <FaFileContract className="text-6xl mb-4 text-green-500 flex flex-col items-center" />
        <h3 className="text-lg font-semibold">Step 2: Deposit your account</h3>
        <p>Deposit your investment account, the higher your deposit the higher you earn.</p>
      </div>
      <div className="step text-center flex items-center flex-col">
        <FaRocket className="text-6xl mb-4 text-purple-500" />
        <h3 className="text-lg font-semibold">Step 3: Start Earning</h3>
        <p>Watch your investments grow over time.</p>
      </div>
    </div>
		<Button className = "font-bold md:mt-[3%] mt-[16%]" size = "lg" variant="ghost" color ="primary" as = "a" href = "/signup"> Get Started </Button>
  </div>
  ); 
}
export default HowToGetStarted; 

